import * as React from "react";
import Modal from "../../../misc/components/modal";
import { LocalizedDateTime, DateTimeAccuracy } from "../../../misc/components/LocalizedDateTime";
import { CoughSession } from "webportalclient";

export interface PostalReceivedModalProps {
    record: CoughSession;

    onClose: () => void;
}

export const PostalReceivedModal = (props: PostalReceivedModalProps) => {
    if (props.record.id) {
        return (
            <Modal show={true} closeModalHandler={() => props.onClose()} header="Postal Information">
                <div className="modal-body">
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <label>Postal Received Date</label>
                            <div>
                                <LocalizedDateTime time={props.record.postalReceived} accuracy={DateTimeAccuracy.Minute} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-footer">
                    <button className="btn btn-primary btn-outline" onClick={() => props.onClose()}>Close</button>
                </div>
            </Modal>
        );
    } else {
        return null;
    }
}
